// extracted by mini-css-extract-plugin
module.exports = {"stackedBar":"style_stackedBar__1G_zF","segment":"style_segment__TvyM4"};